import React from 'react';

const Title = props => {
    return (
        <div className="title">
            <h3>
                SignalR React Chat
            </h3>
        </div>
    )
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/Title.js